import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
// A imperfect workaround to represent variadic parameters (varargs) in typescript

/**
 * Simple cache that caches exactly one item.
 */
export var SimpleCache = /*#__PURE__*/function () {
  /**
   * @param initialValue The initial value, if undefined then the first get() call when initiate the cache value
   *
   * @param supplier The callback that will be called if the cache times out or if no existing value exists for the cache.
   *                 In the case that the supplier throws an exception the error will not be cached. If there's an error
   *                    we will instead return the last known good value but will attempt to refresh the cache again the next time
   *                    get() is called.
   *                 Any parameters passed into get() will be passed through to supplier. Unlike memoize the cache does not
   *                    care about the parameters and will not be invalidated if these parameters change.
   *
   * @param timeoutMs The time to wait before allowing the cache to refresh, this defaults to 15 mins.
   */
  function SimpleCache(supplier) {
    var initialValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var timeoutMs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : SimpleCache.DEFAULT_TIMEOUT_IN_MS;
    _classCallCheck(this, SimpleCache);
    _defineProperty(this, "nextCacheRefreshTime", Date.now());
    this.timeoutMs = timeoutMs;
    this.supplier = supplier;
    this.currentValue = null;
    if (initialValue) {
      this.currentValue = initialValue;
      this.updateNextRefreshTime();
    }
  }
  return _createClass(SimpleCache, [{
    key: "get",
    value: function get() {
      if (!this.currentValue || Date.now() >= this.nextCacheRefreshTime) {
        this.updateNextRefreshTime();
        var exception = new Error('');
        try {
          var result = this.supplier.apply(this, arguments);
          this.currentValue = result;
          if (this.currentValue) {
            return {
              fromCache: false,
              value: this.currentValue
            };
          }
        } catch (e) {
          // If there's an error we will return the last good value but will attempt again on the next get()
          this.invalidate();
          exception = e;
        }
        if (!this.currentValue) {
          var _exception;
          throw new Error("Failed to initialise a value for the cache: ".concat((_exception = exception) === null || _exception === void 0 ? void 0 : _exception.stack));
        }
      }
      return {
        fromCache: true,
        value: this.currentValue
      };
    }

    /**
     * Calls the given supplier and caches the value. If the value is a promise
     * which rejects, the cache will be invalidated and a subsequent call to
     * this function will call the supplier again.
     * @param args
     * @returns
     */
  }, {
    key: "getAsync",
    value: function getAsync() {
      var _this = this;
      var _this$get = this.get.apply(this, arguments),
        fromCache = _this$get.fromCache,
        value = _this$get.value;

      // When the cached value is a promise which rejects, invalidate the cache
      Promise.resolve(value).catch(function () {
        return _this.invalidate();
      });
      return {
        fromCache: fromCache,
        value: value
      };
    }
  }, {
    key: "invalidate",
    value: function invalidate() {
      this.nextCacheRefreshTime = Date.now();
    }
  }, {
    key: "updateNextRefreshTime",
    value: function updateNextRefreshTime() {
      this.nextCacheRefreshTime = Date.now() + this.timeoutMs;
    }
  }]);
}();
_defineProperty(SimpleCache, "DEFAULT_TIMEOUT_IN_MS", 15 * 60 * 1000);